import { Link } from 'react-router-dom';
import { QuickTermsEmbed } from '@quickterms/sdk/react';

interface PolicyPageProps {
  docId: string;
}

export function PolicyPage({ docId }: PolicyPageProps) {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-center sm:justify-start h-16">
            <Link to="/" className="flex items-center space-x-2">
              <img src="/logo.png" alt="" className="h-8 w-8" />
              <img src="/logo-text.png" alt="Statsmatic" className="h-6" />
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-gray max-w-none">
          <QuickTermsEmbed
            docId={docId}
            showTitle={false}
            showFooter={false}
            className="quickterms-content"
          />
        </div>
      </main>

      {/* Footer */}
      <footer className="py-12 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <Link to="/" className="flex items-center space-x-2">
              <img src="/logo.png" alt="" className="h-8 w-8" />
              <img src="/logo-text.png" alt="Statsmatic" className="h-6" />
            </Link>
            <div className="mt-4 md:mt-0 text-gray-500 text-sm text-center md:text-right">
              <p>
                &copy; {new Date().getFullYear()}{' '}
                <a href="https://horizon-group.io" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">
                  Horizon Group
                </a>
                . All rights reserved.
                <span className="hidden sm:inline"> Built with ❤️ by{' '}
                  <a href="https://jason.camp" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">
                    Jason Camp
                  </a>
                </span>
              </p>
              <p className="sm:hidden mt-1">
                Built with ❤️ by{' '}
                <a href="https://jason.camp" target="_blank" rel="noopener noreferrer" className="hover:text-gray-700">
                  Jason Camp
                </a>
              </p>
              <p className="mt-2">
                <Link to="/privacy" className="hover:text-gray-700">Privacy Policy</Link>
                <span className="mx-2">·</span>
                <Link to="/terms" className="hover:text-gray-700">Terms of Service</Link>
                <span className="mx-2">·</span>
                <Link to="/disclaimer" className="hover:text-gray-700">Disclaimer</Link>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PolicyPage;
